export enum AppAction {
    INIT_APP = 'GTCN/APP/INIT',
    SET_CUSTOMER = 'GTCN/APP/SET_CUSTOMER',
    SET_LOADING = 'GTCN/APP/SET_LOADING',
    SET_OVERLAY_VISIBILITY = 'GTCN/APP/SET_OVERLAY_VISIBILITY',
    SET_OVERLAY_LOADED = 'GTCN/APP/SET_OVERLAY_LOADED',
    SET_ERROR = 'GTCN/APP/SET_ERROR',
    SET_SELECTED_GIGAKOMBI = 'GTCN/APP/SET_SELECTED_GIGAKOMBI',
    GET_PRODUCT_DETAILS = 'GTCN/APP/GET_PRODUCT_DETAILS',
    SET_PRODUCT_DETAILS = 'GTCN/APP/SET_PRODUCT_DETAILS',
    SET_SELECTED_PRODUCT = 'GTCN/APP/SET_SELECTED_PRODUCT',
};
